/******************************************************************************************

     _                      _             
    (_) _ __   ____  _ _   (_) _ __  __ _ 
    | |( '_ '\/ ,__)( '_'\ | |( '__)/'_' )
    | || | ) )\__, \| (_) )| || |  ( (_| |
    (_)(_) (_)(____/|  __/ (_)(_)   \__,_)
                    | |                   
                    (_)                   

    Inspira Digital Alterations - General Script
    =============================================
    

******************************************************************************************/

console.log('%cinspira digital', 'font-size:28px;font-weight:bold;color:#009ee2;text-shadow:0 1px 0 #ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 10px 10px rgba(0,0,0,.15);');
console.log('%cmaking sense of the web since 2008','font-size:12.3px;color:#aaa;padding-left: 1.9px;');

var Inspira = (function($) {
  
  function resizeSideCart() {
    $('.scart .sproducts')
    .css('max-height',$(window).height()-$('.scart .stotal').height()-$('.header-bar').height()-14)
    
    .css('overflow','auto');
  }
  
  return resizeSideCart;
  
})(jQuery);

var Cart = (function($, Shopify) {
  var list = '.sproducts';
  var total = '.shoppingbag-total';

  function updateTotal() {
    Shopify.getCart(function(data) { 
      $(total).text(Shopify.formatMoney(data.total_price, '£\{\{amount}}'));
    });
  }
  
  function renderItem(item) {
    var html = '';
    
    html += ''+
      '<div class="sproduct cart-list-item" id="'+item.id+'" style="transition: background-color 1s linear !important; -moz-transition: background-color 1s linear !important; -webkit-transition: background-color 1s linear !important; -ms-transition: background-color 1s linear !important; background-color: #ffff99;" >'+
      	'<div class="sproduct-img">'+
      		'<img src="'+item.image+'" alt="" width="54" height="45" />'+
      	'</div>'+
      	'<div class="sproduct-info">'+
      		'<h5 class="sproduct-title"><a href="">'+item.title+' - '+item.variant_options[0]+'</a></h5>'+
      		'<p class="sproduct-price" data-item-price="'+item.price+'">'+Shopify.formatMoney(item.price, '£\{\{amount}}')+' Each</p>'+
      		'<div class="sproduct-actions">'+
      			'<div class="box">'+
      				'<input name="quantity-field" type="text" class="field field-quantity" data-quantity-updates data-id="'+item.id+'" value="'+item.quantity+'" />'+
      				'<a class="qy-minus" href="#"><i class="icon-minus"></i></a>'+
      				'<a class="qy-plus" href="#"><i class="icon-plus"></i></a>'+
      			'</div>'+
      			'<a href="#" class="delete-sproduct remove-product"><i class="icon-x-gray-small"></i></a>'+
      		'</div>'+
      		'<div data-quantity-total>'+Shopify.formatMoney(item.line_price, '£\{\{amount}}')+'</div>'+
      	'</div>'+
      '</div>'
    ;

    if($(list).length) {
      $(list).prepend(html);
      setTimeout(function(){$(list).children().first().css('background-color','#fff')},1000);
    }
  }

  function removeItemListing(id, replacing) {
    replacing = replacing || null;
    var $item = $('#'+id);

    if($item.length) {
      if(replacing) {
        $item.remove();
      } else {
        $item.fadeOut().promise().done(function() {
          $item.remove();
        });
      }
    }
  }
  
  function isInCart(id) {
    var found = false;

    if($('#'+id).length)
      found = true;

    return found;
  }

  function removeItem(id) {
    Shopify.removeItem(id, function() {
      removeItemListing(id);
      updateTotal();
    });
  }
  
  function addItem(item) {
    removeItemListing(item.id, true);
    renderItem(item);
    updateTotal();
  }

  function updateQuantity(id, value) {
    Shopify.changeItem(id, value, function(data) {
      updateTotal();

      if(value==0)
        removeItemListing(id);
    });
  }
  
  return {
    updateTotal: updateTotal,
    removeItem: removeItem,
    updateQuantity: updateQuantity,
    addItem: addItem,
    isInCart: isInCart,
  }
  
})(jQuery, Shopify);

(function(document, $, Shopify, Cart, filters) {
  var $doc = $(document);
  
  // call a callback function every *interval* until *stopTime*
  function setIntervalTimeout(callback, interval, stopTime) {
    var i;

    i = setInterval(function() {
      callback();
    }, interval);

    setTimeout(function() {
      clearInterval(i);
    }, stopTime);
  }
  
  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);

    var vars = query.split("&");

    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");
      if(pair[0] == variable){return pair[1];}
    }

    return(false);
  }
  
  $(function() {
    
    // Cart events
    $('[data-cart-add]').submit(function(e) {
      e.preventDefault();
      var id = $(this).find('[name="id"]').val();
      //var quantity = +$(this).find('[name="quantity"]').val();
      var quantity = +$(this).find('[name="quantity-field"]').val();
      var button = $('[data-cart-add]').find('input[type="submit"]');

      button.val('Adding...');
      
      Shopify.addItem(id, quantity, function(item) {
        if(!$('.dd-sc').hasClass('show-dd')) $('.dd-sc .dd-link').click();
        Cart.addItem(item);
        setTimeout(function(){button.val('Added! - Add another?');},1000);
      });
    });

    $doc.on('keyup', '[data-quantity-updates]', function() {
      var id  = $(this).data('id'),
          value = $(this).val();

      if($(this).parents('.cart-list-item').find('[data-quantity-total]').length) {
        var price = $(this).parents('.cart-list-item').find('[data-item-price]').data('item-price');
        $(this).parents('.cart-list-item').find('[data-quantity-total]').text(Shopify.formatMoney(price*value, '£\{\{amount}}'));
      }

      Cart.updateQuantity(id, value);
    });

    $doc.on('click', '.remove-product', function(e) {
      e.preventDefault();
      var id;

      if($(this).parents('.cart-list-item').length) {
        id = $(this).parents('.cart-list-item').attr('id');
      }

      Cart.removeItem(id);
    });
    
    // archived article filtering
    $('#article-filter')
      .change(function() {
        var $posts = $('.archived-posts > div');
        var year = this.value;

        $posts.fadeOut(200).promise().done(function() {
          $('.archived-posts .'+year).fadeIn(400);
        });
      })
      .change()
    ;
    
    // show/hide the recover password form on the login page
    $('.recover-password-trigger').click(function(e) {
      e.preventDefault();
      
      $('#customer-login').toggle();
      $('#recover-password').toggle();
    });
    if(location.hash==='#recover')
      $('.recover-password-trigger:first').trigger('click');
    
    // hide the search form when elsewhere on the page is clicked
    $doc.on('click', function(e) {
      if(
        !$(e.target).parents('.header-search').length &&
        !$(e.target).hasClass('.header-search')
      ) {
        $('.header-search').removeClass('visible');
      }
    });
    
    // filters initializing
    if($('#collection-listing').length) 
      filters.init();
    
    // product reviews formatting display
    function formatSPRForm() {
      $('.spr-form').appendTo($('#popup-review'));
      $('.spr-form-contact').addClass('form-row');
      $('.spr-form-contact-name, .spr-form-contact-email').addClass('form-col');
      $('.spr-form-input').addClass('field');
      $('.spr-form textarea').addClass('textarea');
      $('.spr-form input, .spr-form textarea').wrap('<div class="form-controls"></div>');
      $('.spr-form').show();
    }
    
    function formatReviews() {
      var $container = $('.slider-reviews .slides');
      var html = '';
      var stars = '';
      var name = '';
      var date = '';
      var content = '';
      
      $('.spr-reviews .spr-review').each(function() {
        stars = $(this).find('.spr-starratings').html();
        name = $(this).find('.spr-review-header-byline strong:first').html();
        date = $(this).find('.spr-review-header-byline strong:last').html();
        content = $(this).find('.spr-review-content-body').html();

      	html += ''+
          '<li class="slide">'+
          	'<div class="review-head clearfix">'+
          	  '<p class="author">'+name+' - '+date+'</p>'+
          	  '<a href="#popup-review" class="popup-inline-link">Write A Reviews</a>'+	
          	'</div>'+
          	'<div class="review-box">'+
          	  stars+
          	  '<div class="entry-review">'+
            	'<p>'+content+'</p>'+
          	  '</div>'+
          	'</div>'+
          '</li>'
        ;
      }); 
      
      if(!html) {
        $('.section-reviews-section').hide();
      } else {
      	$container.append(html);
        $('.slider-reviews .slides').bxSlider({
          pager: false,
          nextSelector: '.slider-reviews .slider-controls',
          prevSelector: '.slider-reviews .slider-controls',
          adaptiveHeight: true
        });
      }
    }
    
    setIntervalTimeout(function() {
      if($('.spr-form').length && !$('#popup-review .spr-form').length) {
        formatSPRForm();
        formatReviews();
      }
    }, 3000,5000);


    
    // find a build
    function setPostcode() {
      	var code = getQueryVariable('postcode');
      	if(code) {
          $('#address_search').val(code);
          codeAddress();
        }
    }
    
    function formatBuildForm() {
    	$('.search_bar').addClass('build-search');
      	$('.search_bar button').addClass('form-btn');
      	$('.search_bar button').text('find');
      	$('.search_bar input[type="text"]').addClass('field').wrap('<div class="form-controls"></div>');
      	$('.search_bar select').selecter();
        $('.search_bar select').wrap('<div class="form-controls"></div>');
        $('.search_bar .main_search_bar, .search_bar .search_within_distance, .search_bar .search_limit').addClass('form-col');
      	$('.search_bar button').wrap('<div class="form-actions"></div>');
      	$('.container').addClass('main');
      	$('#col-main').addClass('shell');
      	$('.search_bar .main_search_label').text('Enter postcode');
    }
    
    $('#find-a-build-form').submit(function(e) {
      	e.preventDefault();
      	
      	var code = $(this).find('input[type="text"]').val();
      	code = code.replace(/ /g, '').toLowerCase();
      
    	location.href = '/community/find-a-build?postcode='+code;
    });
    var found = false;
    setIntervalTimeout(function() {
      if($('#store_map').length && !found) {
      	found = true;
        setPostcode();
        formatBuildForm();
      }
    }, 500, 5000);
    
  });
  
})(document, jQuery, Shopify, Cart, filters);

$(window)
.load(function(){
  $('.template-article .slider-controls .bx-prev').nextAll().remove(); // Removes duplicate slider controllers
  
  $('#cc-notification-wrapper > h2 span').text('This website uses cookies, by using this website you provide your consent');
  $('#cc-notification-wrapper .cc-notification-buttons #cc-approve-button-thissite').text('I\'m Good To Go!');
  $('#cc-notification-wrapper #cc-notification-permissions #cc-label-necessary').html('<strong>Strictly Required</strong> This site requires cookies to function - while you cannot edit them here you can turn them off in your browser. Please be aware that aspects of the website might not function with cookies disabled.');
  
  $('#cc-notification-moreinfo').click(function(){
    var button = $(this).parent('h2').siblings('.cc-notification-buttons').find('#cc-approve-button-thissite');

    if (button.text() == 'Save preference'){
      button.text('OK I understand');
    } else {
      button.text('I\'m Good To Go!');
    }
  });
  
  Inspira();
})
.resize(function(){
  Inspira();
});

// We have to write this in old ES5 code couse this website doesn't use webpack yet :( //
var selectHelper = function(){

  // Works only on the product form

    var isFirefox = typeof InstallTrigger !== 'undefined';
    if(isFirefox) {
      $('select').toggleClass('firefox');
      
    }

}
$(function(){
  // if this code doesn't work, its due to 1 last thing, which I can likely fix //
  // Remove line 22 and 26 if this code is placed inside of a clouser function already //
  selectHelper();
})